import { defineStore } from 'pinia'
import { reactive } from 'vue'

export const useHeaderStore = defineStore('header', () => {
  interface HeaderContext {
    el: HTMLElement | undefined,
    height: number,
    isShow: boolean,
  }

  const context: HeaderContext = reactive({
    el: undefined,
    isShow: false,
    height: 0,
  })

  const updateShowStatus = (status: boolean) => {
    context.isShow = status
  }

  /**
   * ヘッダーの高さ変化を監視する
   *
   * @description
   *  高さはマウント直後に確定しない（グローバルナビの描画などで後から変わる）ため、
   *  要素自体のサイズ変化を監視して都度取り直す。
   *  画面幅の変化による高さ変化もこの監視で拾えるので、resize イベントの監視は不要。
   *
   *  このストアはアプリ生存期間のシングルトンで、監視対象はヘッダー要素 1 つだけ。
   *  解除を onBeforeUnmount に託すと「最初に useHeaderStore() を呼んだコンポーネント」に
   *  紐づいてしまい、それがヘッダーより先に消えると監視だけ止まる。
   *  ヘッダーが差し替わったときは setHeaderElement が張り直すため、明示的な解除は持たない
   */
  const heightObserver = new ResizeObserver(() => setHeight())

  const setHeaderElement = (el: HTMLElement) => {
    context.el = el
    setHeight()

    heightObserver.disconnect()
    heightObserver.observe(el)
  }

  const setHeight = () => {
    context.height = context.el?.clientHeight || 0
  }

  return {
    // data
    context,

    // method
    updateShowStatus,
    setHeaderElement,
  }
})
